/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as UserDashboardPageLoader } from './UserDashboardPage/UserDashboardPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as ProfileSettingsPageLoader } from './ProfileSettingsPage/ProfileSettingsPage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as WorkshopPageLoader } from './WorkshopPage/WorkshopPage';
import { loadData as WorkshopTypePageLoader } from './WorkshopPage/WorkshopTypePage';
import { loadData as WorkshopProductPageLoader } from './WorkshopPage/WorkshopProductPage';
import { loadData as WorkshopCategoryPageLoader } from './WorkshopPage/WorkshopCategoryPage';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import { loadData as DashboardPageLoader } from './DashboardPage/DashboardPage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as SubscriptionPageLoader } from './SubscriptionPage/SubscriptionPage.duck';
import { loadData as SeoTypePageLoader } from './SeoTypePage/SeoTypePage.duck';
import {
  loadData as SeoCategoryPageLoader,
  loadBlogData as SingleBlogPageLoader,
  loadBlogListData as BlogPageLoader,
  loadStateData as StateListsPageLoader,
  faqLoadData as FAQPageLoader,
} from '../ducks/strapi.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    DashboardPage: {
      loadData: DashboardPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    UserDashboardPage: {
      loadData: UserDashboardPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    ProfileSettingsPage: {
      loadData: ProfileSettingsPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    SubscriptionPage: {
      loadData: SubscriptionPageLoader,
    },
    SeoTypePage: {
      loadData: SeoTypePageLoader,
    },
    SeoCategoryPage: {
      loadData: SeoCategoryPageLoader,
    },
    BlogPage: {
      loadData: BlogPageLoader,
    },
    SingleBlogPage: {
      loadData: SingleBlogPageLoader,
    },
    StateListsPage: {
      loadData: StateListsPageLoader,
    },
    FAQPage: {
      loadData: FAQPageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    WorkshopPage: {
      loadData: WorkshopPageLoader,
    },
    WorkshopTypePage: {
      loadData: WorkshopTypePageLoader,
    },
    WorkshopProductPage: {
      loadData: WorkshopProductPageLoader,
    },
    WorkshopCategoryPage: {
      loadData: WorkshopCategoryPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
